"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePropsValue = exports.useForceUpdate = exports.useWatch = exports.useStateRef = exports.useRefVal = exports.usePrevState = exports.useThrottle = exports.useDebounce = void 0;
var react_1 = require("react");
var use_force_update_1 = require("./use-force-update");
Object.defineProperty(exports, "useForceUpdate", { enumerable: true, get: function () { return use_force_update_1.useForceUpdate; } });
var use_watch_1 = require("./use-watch");
Object.defineProperty(exports, "useWatch", { enumerable: true, get: function () { return use_watch_1.useWatch; } });
var use_props_value_1 = require("./use-props-value");
Object.defineProperty(exports, "usePropsValue", { enumerable: true, get: function () { return use_props_value_1.usePropsValue; } });
/**
 * 防抖 触发高频事件后n秒内函数只会执行一次，如果n秒内事件再次被触发，则重新计算时间
 * @param fn 要执行的函数
 * @param delay 延时
 * @param dep 依赖项
 * @returns
 */
var useDebounce = function (fn, delay, dep) {
    if (dep === void 0) { dep = []; }
    var current = react_1.useRef({ fn: fn, timer: null }).current;
    react_1.useEffect(function () {
        current.fn = fn;
    }, [fn]);
    return react_1.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (current.timer) {
            clearTimeout(current.timer);
        }
        current.timer = setTimeout(function () {
            var _a;
            (_a = current.fn).call.apply(_a, __spreadArray([_this], __read(args)));
        }, delay);
    }, dep);
};
exports.useDebounce = useDebounce;
/**
 * 节流 高频事件频发 但是n秒内只会执行一次，所以节流会稀释函数的执行频率
 * @param fn
 * @param delay
 * @param dep
 * @returns
 */
var useThrottle = function (fn, delay, dep) {
    if (dep === void 0) { dep = []; }
    var current = react_1.useRef({ fn: fn, timer: null }).current;
    react_1.useEffect(function () {
        current.fn = fn;
    }, [fn]);
    return react_1.useCallback(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!current.timer) {
            current.timer = setTimeout(function () {
                delete current.timer;
            }, delay);
            (_a = current.fn).call.apply(_a, __spreadArray([_this], __read(args)));
        }
    }, dep);
};
exports.useThrottle = useThrottle;
/**
 * 返回一个传入值的 ref
 */
function useRefVal(val) {
    var ref = react_1.useRef(val);
    ref.current = val;
    return ref;
}
exports.useRefVal = useRefVal;
/**
 * 跟 useState 一样
 * - 第三个参数返回 `state` 的ref
 */
function useStateRef(initialState) {
    var _a = __read(react_1.useState(initialState), 2), state = _a[0], setState = _a[1];
    return [state, setState, useRefVal(state)];
}
exports.useStateRef = useStateRef;
// const [loginInfo, setLoginInfo, loginInfoRef] = hooks.useStateRef<DzLogin.LoginUserInfo|null>(null);
/**
 * 获取改变前上一个值
 *
 * @param targetValue 当前值
 * @param initLast 初始化时的`上一个值`
 * @returns 上一个值
 */
var usePrev = function (targetValue, initLast) {
    var ref = react_1.useRef({
        pre: typeof initLast === 'undefined' ? targetValue : initLast,
        cur: targetValue,
    });
    if (targetValue !== ref.current.cur) {
        ref.current.pre = ref.current.cur;
        ref.current.cur = targetValue;
    }
    return ref.current.pre;
};
function isFunction(val) {
    return typeof val === 'function';
}
/**
 * 尝试执行函数
 * - 不是函数则返回该值
 * - context
 */
function tryExecFunc(fn) {
    var other = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        other[_i - 1] = arguments[_i];
    }
    if (isFunction(fn)) {
        return fn.call.apply(fn, __spreadArray([fn], __read(other)));
    }
    return fn;
}
/**
 * 跟 useState 类似
 * - 第三个参数返回上一个的值
 *
 * @param initialState 初始化的值
 * @param initialPrevState 初始化时`上一个`的值 默认`跟初始化`的值一样
 */
function usePrevState(initialState, initialPrevState) {
    if (initialPrevState === void 0) { initialPrevState = tryExecFunc(initialState); }
    var _a = __read(react_1.useState(initialState), 2), state = _a[0], setState = _a[1];
    return [state, setState, usePrev(state, initialPrevState)];
}
exports.usePrevState = usePrevState;
